
import React, {Component} from 'react';
import {connect} from 'react-redux'
import PrintPreview from '../PrintPreview'
import ReportStockListInOut from '../../report/stock/ReportStockListInOut'
import ReportStore from 'stores/ReportStore'
import Moment from 'moment';

const YEAR = (Moment(new Date()).format("YYYY")*1)+543
const START_DATE = '01/01/'+YEAR
const END_DATE = '01/12/'+YEAR
// const MobileDetect = require('mobile-detect')
const DEFAULT_ROW = 21
class PrintReportStockListInOut extends Component {

  constructor(props){
    super(props)

    // let md = new MobileDetect(window.navigator.userAgent);
    // let sliptable_page = ''
    // let title_destop = ''
    // if(md.is('iOS') || md.is('AndroidOS')){ 
    //   sliptable_page = 'sliptable-page iv-olview'
    // } else { 
    //   sliptable_page = 'sliptable-page-destop iv-olview'
    //   title_destop = 'title-destop'
    // }

    this.state = {
      // title_destop:title_destop,
      // sliptable_page:sliptable_page,
      data:{data:[],dataFormat:[]},
      report_title:this.props.messages['Fetching']+'..'
    }

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    let pSize = (this.props.typePrint==='chart'?'landscape':'portrait')
    cssPagedMedia.size(pSize);
  }

  componentDidMount() {
    if (this.props.typePrint==='chart') {
      this.refs.report_stocklist_inout.getWrappedInstance().loadReportStockListInOut(this.props.start_date, this.props.end_date)
    } else {
      this.loadReportStockListInOut(this.props.start_date, this.props.end_date)
    }
  }  

  loadReportStockListInOut(start_date=START_DATE, end_date=END_DATE) {
    let day_start = start_date.substring(0,2)
    let month_start = start_date.substring(3,5)
    let year_start = (start_date.substring(6,10)*1)-543
    let en_start = day_start+'/'+month_start+'/'+year_start
    let day_end = end_date.substring(0,2)
    let month_end = end_date.substring(3,5)
    let year_end = (end_date.substring(6,10)*1)-543
    let en_end = day_end+'/'+month_end+'/'+year_end
    let {data} = this.state
    ReportStore.loadReportStockListInOut(en_start,en_end,(result)=> {
        data.data = result.data
        data.dataFormat = this.getPagination(result.data)
        this.setState({data:data,report_title:this.props.messages['Data Not Found']})
    })
  }

  getPagination(data) {
    let newData = []
    let allData = []
    let checkRow = 0

    data.forEach(function(item,index) {
        if (checkRow<DEFAULT_ROW)
          checkRow++
          newData.push(item)

        if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
          allData.push(newData)
          checkRow = 0
          newData = []
        }
    }) 
    
    return allData
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  renderRowData(data,index,length) {
    let {typePrice,messages} = this.props
    if (data.length===0) {
        return(<tr><td colSpan={typePrice===''?11:9}>{messages['Data Not Found']}</td></tr>)
    } else {
        return(
            data.map((item,index)=>{
                return(
                    <tr key={index}>
                        <td className='text-center'>{index+1}</td>
                        <td className='text-center'>{item.productcode}</td>
                        <td>{item.detail}</td>
                        <td className='text-center'>{item.in_quantity}</td>
                        <td className='text-center'>{item.out_quantity}</td>
                        <td className='text-center'>{item.balance_quantity}</td>
                        {typePrice==='unit'||typePrice===''||typePrice===undefined?<td className='text-right'>{this.getNumberFormat(item.cost_per_unit)}</td>:''}
                        {typePrice==='total'||typePrice===''||typePrice===undefined?<td className='text-right'>{this.getNumberFormat(item.cost_amount)}</td>:''}
                        {typePrice==='unit'||typePrice===''||typePrice===undefined?<td className='text-right'>{this.getNumberFormat(item.sale_per_unit)}</td>:''}
                        {typePrice==='total'||typePrice===''||typePrice===undefined?<td className='text-right'>{this.getNumberFormat(item.sale_amount)}</td>:''}
                        <td>{item.remark}</td>
                    </tr>   
                )
            })
        )
    }
  }

  getSummary(data,field) {
    let sum = 0
    data.forEach((item,index)=>{
      let val = (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
      sum += val
    })
    return sum
  }

  renderTable(data,index,length) {
    let {typePrice,messages} = this.props
    return(
        <div className="report-stocklist-inout">
            <table className="table table-hover table-print">
                <thead>
                    <tr>
                        <th rowSpan={2} style={{width:"5%"}} className="text-center">{messages['Number']}</th>
                        <th rowSpan={2} style={{width:"10%"}} className="text-center">{messages['Product Number']}</th>
                        <th rowSpan={2} style={{width:"35%"}} className="text-center">{messages['Product List']}</th>
                        <th colSpan={3} className="text-center">{messages['Quantity']}</th>
                        <th colSpan={typePrice===''||typePrice===undefined?4:2} className="text-center">{messages['Price']}</th>
                        <th rowSpan={2} style={{width:"15%"}} className="text-center">{messages['Remark']}</th>
                    </tr>
                    <tr>
                        <th style={{width:"7%"}} className='text-center'>{messages['In']}</th>
                        <th style={{width:"7%"}} className='text-center'>{messages['Out']}</th>
                        <th style={{width:"7%"}} className='text-center'>{messages['Balance']}</th>
                        {typePrice==='unit'||typePrice===''||typePrice===undefined?<th style={{width:"7%"}} className='text-center'>{messages['Buy']}</th>:''}
                        {typePrice==='total'||typePrice===''||typePrice===undefined?<th style={{width:"7%"}} className='text-center'>{messages['Total Buy']}</th>:''}
                        {typePrice==='unit'||typePrice===''||typePrice===undefined?<th style={{width:"7%"}} className='text-center'>{messages['Sale']}</th>:''}
                        {typePrice==='total'||typePrice===''||typePrice===undefined?<th style={{width:"7%"}} className='text-center'>{messages['Total Sale']}</th>:''}
                    </tr>
                </thead>
                <tbody>
                    {this.renderRowData(data,index,length)}
                    {index===length
                    ?
                    <tr>
                      <td colSpan={3}></td>
                      <td className='text-center'>{this.getNumberFormat(this.getSummary(data,'in_quantity'))}</td>
                      <td className='text-center'>{this.getNumberFormat(this.getSummary(data,'out_quantity'))}</td>
                      <td className='text-center'>{this.getNumberFormat(this.getSummary(data,'balance_quantity'))}</td>
                      {typePrice==='total'
                      ?
                      [<td key={'t-0'} className='text-right'>{this.getNumberFormat(this.getSummary(data,'cost_amount'))}</td>,
                      <td key={'t-1'} className='text-right'>{this.getNumberFormat(this.getSummary(data,'sale_amount'))}</td>,
                      <td key={'t-2'} className='text-center'></td>]
                      :typePrice==='unit'
                      ?
                      <td colSpan={3}></td>
                      :
                      [<td key={'a-0'} className='text-right' colSpan={2}>{this.getNumberFormat(this.getSummary(data,'cost_amount'))}</td>,
                      <td key={'a-1'} className='text-right' colSpan={2}>{this.getNumberFormat(this.getSummary(data,'sale_amount'))}</td>,
                      <td key={'a-2'} className='text-center'></td>]}
                    </tr>
                    :''}
                </tbody>
            </table>
        </div>
    )
  }

  renderComponentPage(data,index,length) {
    return(
          // <div className="a4-onlineview report-stocklist-inout" key={index}>
          //   <div className={this.state.sliptable_page+' font-print'}>
          //     <div className="no-of-page">
          //       <span>{this.props.messages['Page']} {index+1}/{length+1}</span>
          //     </div>
          //     <header className="align-center">
          //       <h2 className={this.state.title_destop}>{this.props.messages['Stock List In Out Report Table']}<p className='sub-title' style={{fontSize:'20px'}}>{this.props.messages['Start']+' '+this.props.start_date+' '+this.props.messages['To']+this.props.end_date}</p></h2>
          //     </header>
          //     <div className=''>
          //       {this.renderTable(data,index,length)}
          //     </div>  
          //   </div>                      
          // </div>
          <div className='report-stocklist-inout font-print' key={index}>
            <header className="text-center">
                <h2>
                  {this.props.messages['Stock List In Out Report Table']}<p className='sub-title' style={{fontSize:'20px'}}>{this.props.messages['Start']+' '+this.props.start_date+' '+this.props.messages['To']+' '+this.props.end_date}</p>
                </h2>
            </header>
            <div>
                {this.renderTable(data,index,length)}
            </div>
          </div>
    )
  }

  renderNoData() {
    return(
      <div className='font-print'>
        <header className="text-center">
          <h2>{this.state.report_title}</h2>
        </header>
      </div>
    )
  }

  render(){
    let {data} = this.state
    let {start_date, end_date, typePrint} = this.props
    
    if (typePrint==='chart') {
      return(
        <div>
          <PrintPreview
            size={'landscape'}
          >
            <ReportStockListInOut 
              typePrint={'chart'}
              start_date={start_date}
              end_date={end_date}
              showPrintPreview={true}
              ref='report_stocklist_inout'
            >
            </ReportStockListInOut>  
          </PrintPreview>
        </div>
      )
    } else {
      if (data.dataFormat.length===0) {
        return(
          <div>
            <PrintPreview
              size={'portrait'}
            >
              {this.renderNoData()}
            </PrintPreview>
          </div>
        )
      } else {
        return(
          <div>
            <PrintPreview
              size={'portrait'}
            >
              {
                data.dataFormat.map((item,index) => {
                  return(
                    this.renderComponentPage(item,index,data.dataFormat.length-1)
                  )
                })
              }
            </PrintPreview>
          </div>
        )
      }  
    }
  }
}

export default PrintReportStockListInOut = connect(
  (state) => ({messages: state.message.view.print.stock.PrintReportStockListInOut}),null,null,{withRef:true}
)(PrintReportStockListInOut);





// WEBPACK FOOTER //
// ./src/view/print/stock/PrintReportStockListInOut.js